// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__130mH","head":"ProcedureTableInfo_head__1wBGY"};